import React, { useEffect, useRef } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const CenterInfoSection = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    let mapInstance = null;

    const initMap = () => {
      if (!mapRef.current) return;

      try {
        window.ymaps.ready(() => {
          if (!mapRef.current) return;

          mapInstance = new window.ymaps.Map(mapRef.current, {
            center: [45.067494, 38.962880],
            zoom: 16,
            controls: ['zoomControl', 'fullscreenControl'],
          });

          // Добавляем метку
          const placemark = new window.ymaps.Placemark(
            [45.067494, 38.962880],
            {
              balloonContent: `
                <div style="padding: 10px;">
                  <strong>Консультационный центр "Волшебная страна"</strong><br/>
                  МАДОУ МО г. Краснодар «Детский сад № 213»<br/>
                  350078 г. Краснодар ул. им. Тургенева, д. 185
                </div>
              `,
              iconCaption: 'Консультационный центр "Волшебная страна"',
            },
            {
              preset: 'islands#redIcon',
            }
          );

          mapInstance.geoObjects.add(placemark);
          // Отключаем масштабирование колесиком мыши для лучшего UX
          mapInstance.behaviors.disable('scrollZoom');
        });
      } catch (error) {
        console.error('Ошибка инициализации карты:', error);
      }
    };

    // Загружаем Яндекс.Карты API
    if (!window.ymaps) {
      const script = document.createElement('script');
      script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
      script.async = true;
      document.head.appendChild(script);
      
      script.onload = () => {
        if (window.ymaps) {
          initMap();
        }
      };

      script.onerror = () => {
        console.error('Ошибка загрузки Яндекс.Карт API');
      };
    } else {
      initMap();
    }

    // Очистка при размонтировании
    return () => {
      if (mapInstance) {
        mapInstance.destroy();
      }
    };
  }, []);

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#f9f9f9' }}>
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Левая часть - информация о центре */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                background: 'linear-gradient(135deg, #00ACC1 0%, #4DB6AC 100%)',
                color: 'white',
                boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              }}
            >
              <CardContent sx={{ p: 5 }}>
                <Typography
                  variant="h3"
                  sx={{
                    mb: 4,
                    fontWeight: 700,
                    fontSize: { xs: '1.1rem', sm: '1.5rem', md: '2.25rem' },
                    lineHeight: 1.3,
                    maxWidth: '100%',
                    overflow: 'hidden',
                  }}
                >
                  <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                    Консультационный{'\u00A0'}центр
                  </Box>
                  <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                    "Волшебная{'\u00A0'}страна"
                  </Box>
                </Typography>

                <Box sx={{ mb: 4 }}>
                  <Typography variant="body1" sx={{ mb: 1, opacity: 0.9, fontStyle: 'italic', fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                    МАДОУ МО г.{'\u00A0'}Краснодар «Детский{'\u00A0'}сад{'\u00A0'}№{'\u00A0'}213»
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                    <LocationOnIcon sx={{ mr: 1, mt: 0.5, flexShrink: 0 }} />
                    <Typography variant="body1" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                      350078 г.{'\u00A0'}Краснодар ул.{'\u00A0'}им.{'\u00A0'}Тургенева, д.{'\u00A0'}185
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PhoneIcon sx={{ mr: 1 }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      +7(918)213-03-33
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ mr: 1 }} />
                    <Typography variant="body1">
                      wonderland_2023@mail.ru
                    </Typography>
                  </Box>
                </Box>

                {/* QR код */}
                <Box
                  component="img"
                  src="/img/1_5.jpg"
                  alt="QR-код"
                  sx={{
                    width: 150,
                    height: 150,
                    backgroundColor: 'white',
                    borderRadius: 2,
                    mt: 3,
                    objectFit: 'contain',
                    p: 1,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Правая часть - карта */}
          <Grid item xs={12} md={7}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 4,
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              }}
            >
              {/* Яндекс.Карта */}
              <Box
                ref={mapRef}
                sx={{
                  width: '100%',
                  height: { xs: 400, md: '100%' },
                  minHeight: 500,
                  backgroundColor: '#e0e0e0',
                  position: 'relative',
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CenterInfoSection;
